import * as React from 'react';
import * as ReactGA from 'react-ga';
import { RouteProps } from 'react-router';
import { Location } from 'history';

export interface IGoogleAnalyticsProps extends RouteProps {}

class GoogleAnalytics extends React.PureComponent<IGoogleAnalyticsProps> {
    static save(location: Location) {
        if (process.env.NODE_ENV !== 'production') {
            return;
        }
        if (
            location.pathname === '/callback' ||
            location.pathname === '/silent-callback'
        ) {
            return;
        }
        ReactGA.set({ page: location.pathname + location.search });
        ReactGA.pageview(location.pathname + location.search);
    }

    render() {
        return <div />;
    }
}

export default GoogleAnalytics;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/GoogleAnalytics.tsx